import * as API from "../api/CMKApi";
import { call, put, takeLatest } from 'redux-saga/effects'
import {
    findPatientsSucceed,
    hideVisitDetails,
    loadPatientDetails,
    loadPatientDetailsSucceed, loadPatientsReportDataSucceed,
    loadTherapistsSucceed,
    loadVisits, loadVisitsReportData, loadVisitsReportDataSucceed,
    loadVisitsSucceed,
    setConflictedTerms,
    setErrorMessage, setVisitsIdsForReports,
} from "../store/actions";
import {
    CANCEL_VISIT,
    FIND_PATIENTS,
    LOAD_PATIENT,
    LOAD_PATIENT_DETAILS, LOAD_PATIENTS_REPORT_DATA,
    LOAD_THERAPISTS,
    LOAD_VISITS, LOAD_VISITS_REPORT_DATA, MASS_ACTION_ON_VISITS,
    SAVE_THERAPY,
    UPDATE_PATIENT,
    UPDATE_THERAPY_TERM
} from "../store/actions/actionTypes";
import { store } from "../store/helpers";

const getSelectedDate = () => store.getState().cmk.selectedBaseDate;

function* _findPatients(action) {
    try {
        const response = yield call(API.findPatients, action.payload);
        yield put(findPatientsSucceed(response.data));
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _loadPatient(action) {
    if (action.payload > 0) {
        try {
            const response = yield call(API.loadPatient, action.payload);
            yield put(findPatientsSucceed(response.data));
        } catch (e) {
            console.log('ERROR', e)
        }
    }
}

function* _loadPatientDetails(action) {
    try {
        const response = yield call(API.loadPatientDetails, action.payload);
        yield put(loadPatientDetailsSucceed(response.data));
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _updatePatient(action) {

    try {
        yield call(API.updatePatient, action.payload.id, action.payload.patientData);
        yield put(loadPatientDetails(action.payload.id));
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _loadTherapists() {
    try {
        const response = yield call(API.loadTherapists)
        yield put(loadTherapistsSucceed(response.data))
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _loadVisits() {
    try {
        yield put(setErrorMessage(''));
        const response = yield call(API.loadVisitsInDate, getSelectedDate());
        yield put(loadVisitsSucceed(response.data));
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _saveTherapy(action) {
    try {
        const therapyData = action.payload;
        yield put(setErrorMessage(''));
        const response = yield call(API.addTherapy, therapyData);
        if (response.status === 201) {
            yield put(hideVisitDetails());
            yield put(loadVisits())
        } else if (response.status === 200) {
            if (response.data.status === 'error') {
                if (response.data.terms) yield put(setConflictedTerms(response.data.terms));
                if (response.data.message) yield put(setErrorMessage(response.data.message));
            }
        }
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _updateTherapyTerm(action) {
    try {
        const { id, therapyData } = action.payload;
        yield put(setErrorMessage(''));
        const response = yield call(API.updateTherapy, id, therapyData);
        if (response.data.status === 'error') {
            if (response.data.terms) yield put(setConflictedTerms(response.data.terms));
            if (response.data.message) yield put(setErrorMessage(response.data.message));
        } else {
            yield put(hideVisitDetails());
            yield put(loadVisits())
        }
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _cancelVisit(action) {
    const { id, paid, permanent } = action.payload;
    try {
        yield call(API.cancelTherapy, id, paid, permanent);
        yield put(loadVisits())
    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _loadVisitsReportData(action){
    let period = action.payload;
    if (period === undefined) {
        period = store.getState().reports.reports_period.value
    }
    try {
        const response = yield call(API.visitsReport, period);
        yield put(setVisitsIdsForReports([]));
        yield put(loadVisitsReportDataSucceed(response.data))

    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _loadPatientsReportData(action) {
    let period = action.payload;
    if (period === undefined) {
        period = store.getState().reports.reports_period.value
    }
    try {
        const response = yield call(API.patientsReport, period);
        yield put(loadPatientsReportDataSucceed(response.data))

    } catch (e) {
        console.log('ERROR', e)
    }
}

function* _massActionOnVisits(action) {
    const actionName = action.payload;
    try {
        yield call(API.massActionOnVisits, actionName, store.getState().reports.selected_visit_ids);
        yield put(setVisitsIdsForReports([]));
        yield put(loadVisitsReportData())

    } catch (e) {
        console.log('ERROR', e)
    }

}

function* serviceSaga() {
    yield takeLatest(FIND_PATIENTS, _findPatients);
    yield takeLatest(LOAD_PATIENT, _loadPatient);
    yield takeLatest(LOAD_PATIENT_DETAILS, _loadPatientDetails);
    yield takeLatest(UPDATE_PATIENT, _updatePatient);
    yield takeLatest(LOAD_THERAPISTS, _loadTherapists);
    yield takeLatest(LOAD_VISITS, _loadVisits);
    yield takeLatest(SAVE_THERAPY, _saveTherapy);
    yield takeLatest(UPDATE_THERAPY_TERM, _updateTherapyTerm);
    yield takeLatest(CANCEL_VISIT, _cancelVisit);
    yield takeLatest(LOAD_VISITS_REPORT_DATA, _loadVisitsReportData);
    yield takeLatest(LOAD_PATIENTS_REPORT_DATA, _loadPatientsReportData);
    yield takeLatest(MASS_ACTION_ON_VISITS, _massActionOnVisits);
}

export default serviceSaga;


// WEBPACK FOOTER //
// ./src/middlewares/sagas.js